"use client"

import { useItemCount } from "./use-item-count"
import { useMiniCartStore } from "./use-new-minicart-store"
import classes from "./minicart-new-trigger.module.css"

export default function MiniCartNewTrigger() {
  const setCartStatus = useMiniCartStore((state) => state?.setCartStatus)
  const { itemCount } = useItemCount()

  const itemCountDisplay = itemCount > 99 ? "99+" : itemCount

  const maybeItemCounter = (
    <span data-cy="CartTrigger-counter">{itemCountDisplay}</span>
  )

  return (
    <div
      className="relative flex cursor-pointer items-center justify-center rounded-[5px] hover_bg-[#F7F7F5] lg_h-[45px] lg_w-[45px]"
      onClick={() => {
        setCartStatus("cartopen")
      }}
    >
      <div className={classes.icon} />
      <div className="absolute right-[-6px] top-[-6px] min-w-[16px] rounded-full bg-primary px-1 py-0 text-center text-[12px] leading-[16px] text-white lg_right-[4px] lg_top-[4px] lg_min-w-[1.25rem] lg_leading-[20px]">
        {maybeItemCounter}
      </div>
    </div>
  )
}
